import {ReactNode} from "react";
import {Button, ButtonProps} from "@mui/material";
import {styled} from "@mui/material/styles";
import {ArrowBack, ArrowForward} from "@mui/icons-material";

export type TextButtonIconType = "none" | "check" | "back" | "next";
export type ActionButtonColorType = "primary" | "secondary" | "error";

export interface Props extends ButtonProps {
    icon: TextButtonIconType;
    color: ActionButtonColorType;
}

export const TextButton: React.FC<Props> = ({icon, color, children, ...props}) => (
    <StyledButton {...props} variant="text" startIcon={renderIcon(icon)} color={color}>
        {children}
    </StyledButton>
);

const StyledButton = styled(Button)({
    boxShadow: "none",
    textTransform: "uppercase",
    fontSize: 16,
    padding: "6px 12px",
    lineHeight: 1.5,
    paddingX: "20px",
    paddingY: "20px",
    borderRadius: "6px",
    minWidth: "px",
    "&:hover": {
        boxShadow: "none",
    },
});

const renderIcon = (icon: TextButtonIconType): ReactNode => {
    switch (icon) {
        case "none":
            return null;
        case "back":
            return <ArrowBack />;
        case "next":
            return <ArrowForward />;
        default:
            return null;
    }
};
